import {
  et3ParseInteger,
  getOnlyDigitsFromString,
  isNullOrUndefined,
  isPositiveNumber
} from "et3-type-guards";

import { TInputFieldWithLabelProps } from "../../../Types";
import { withLiteObserverAndTheme } from "../../et3-enhanced-render";
import { MAXIMUM_PHONE_NUMBER_DIGITS_ALLOWED } from "../../../constants/input-entries-constants";
import { useEffect } from "react";
import getSupervisorReceiptStore from "../../../stores/supervisor-store/supervisor-receipt-compensation-store";

const Et3InputField = withLiteObserverAndTheme<TInputFieldWithLabelProps>(
  (props) => {
    const {
      label,
      onChoose,
      onBlur,
      onEnter,
      style,
      fieldClassName,
      value,
      type,
      id
    } = props;
    useEffect(() => {
      const tableInputID = getSupervisorReceiptStore().tableInputID.get();
      const getElement = document.getElementById(tableInputID);
      if (getElement) {
        getElement.focus();
      }
    }, []);

    const intValue = parseInt(`${value}`, 10);
    const checkIfPositiveNumber = isPositiveNumber(intValue);
    if (type === "number") {
      return (
        <input
          id={id}
          className={fieldClassName}
          placeholder={`${label}...`}
          value={value}
          onChange={({ target }) => {
            const parsedStringValue = getOnlyDigitsFromString(target.value);
            if (
              parsedStringValue.length < MAXIMUM_PHONE_NUMBER_DIGITS_ALLOWED
            ) {
              const parsedIntegerValue = et3ParseInteger(parsedStringValue);
              onChoose(parsedIntegerValue);
            }
          }}
          onBlur={({ target }) => {
            const parsedStringValue = getOnlyDigitsFromString(target.value);
            const parsedIntegerValue = et3ParseInteger(parsedStringValue);
            onBlur(parsedIntegerValue);
          }}
          onKeyDown={(event) => {
            if (
              event.key === "Enter" &&
              !isNullOrUndefined(onEnter) &&
              checkIfPositiveNumber
            ) {
              onEnter();
            }
          }}
          style={style}
        />
      );
    } else {
      return (
        <input
          type={type}
          className={fieldClassName}
          placeholder={`${label}...`}
          value={value === -1 ? "" : value}
          onChange={({ target }) => {
            onChoose(target.value);
          }}
          onBlur={({ target }) => {
            onBlur(target.value);
          }}
          onKeyDown={(event) => {
            if (event.key === "Enter" && !isNullOrUndefined(onEnter)) {
              onEnter();
            }
          }}
          style={style}
        />
      );
    }
  }
);
export default Et3InputField;
